export function calculatePercentage(percentage) {
  const value = (percentage / 100) * 950;
  return value;
}

export const convertHeightWidth = (value, premium) => {
  if (!value) {
    return 0;
  }
  if (typeof value == 'string') {
    const pattern = /(\d+(\.\d+)?)(%|px|em)?/;
    const match = value.match(pattern);
    const number = parseFloat(match[1]);
    if (value.includes('%') && premium) {
      return calculatePercentage(number);
    }
    return number;
  }
  return value;
};

export const hexToRgba = (hex, alpha) => {
  hex = hex.replace(/^#/, '');

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export function restructureCarouselAlbum(data) {
  const newData = [];
  for (let i = 0; i < data.length; i++) {
    const post = data[i];

    if (post.media_type === 'CAROUSEL_ALBUM' && post.children && post.children.data) {
      const childrenData = post.children.data;

      for (let j = 0; j < childrenData.length; j++) {
        const child = childrenData[j];
        const newPost = { ...post };
        newPost.media_url = child.media_url;
        newPost.media_type = child.media_type;
        delete newPost.children;
        newData.push(newPost);
      }
    } else {
      newData.push(post);
    }
  }
  return newData;
}

export function epochToRelativeDate(timestamp) {
  const dateObj = new Date(timestamp);
  const currentDate = new Date();
  const elapsed = currentDate.getTime() - dateObj.getTime();

  const seconds = Math.floor(elapsed / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(months / 12);

  if (years >= 1) {
    return years === 1 ? '1 year ago' : `${years} years ago`;
  } else if (months >= 1) {
    return months === 1 ? '1 month ago' : `${months} months ago`;
  } else if (days >= 1) {
    return days === 1 ? '1 day ago' : `${days} days ago`;
  } else if (hours >= 1) {
    return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
  } else if (minutes >= 1) {
    return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
  } else {
    return seconds === 1 ? '1 second ago' : `${seconds} seconds ago`;
  }
}

export const getCurrentSymbol = (currency, locale) => {
  let currencySymbol = new Intl.NumberFormat(locale, { style: 'currency', currency })
    .formatToParts(1)
    .find((x) => x.type === 'currency').value;
  if (currencySymbol === 'ZAR') {
    currencySymbol = 'R';
  }
  if (currencySymbol === 'USD') {
    currencySymbol = '$';
  }
  if (currencySymbol === 'EUR') {
    currencySymbol = '€';
  }
  if (currencySymbol === 'GBP') {
    currencySymbol = '£';
  }
  if (currencySymbol === 'JPY') {
    currencySymbol = '¥';
  }
  if (currencySymbol === 'AUD') {
    currencySymbol = 'A$';
  }
  if (currencySymbol === 'CAD') {
    currencySymbol = 'C$';
  }
  if (currencySymbol === 'NZD') {
    currencySymbol = 'NZ$';
  }
  if (currencySymbol === 'INR') {
    currencySymbol = '₹';
  }
  return currencySymbol + ' ';
};

export const calculatePrice = (price, rate) => {
  return price * rate;
};

export const PriceDisplay = (props) => {
  if (props.salePrice && parseFloat(props.salePrice) < parseFloat(props.price)) {
    const [originalIntegerPart, originalFractionalPart] = parseFloat(props.price).toFixed(2).split('.');
    const formattedOriginalIntegerPart = parseInt(originalIntegerPart, 10).toLocaleString();

    const [saleIntegerPart, saleFractionalPart] = parseFloat(props.salePrice).toFixed(2).split('.');
    const formattedSaleIntegerPart = parseInt(saleIntegerPart, 10).toLocaleString();

    return (
      <idk-span style={{ fontSize: props?.fontSize ? props.fontSize : '16px' }}>
        {!props?.discountPriceOnRight && (
          <>
            <idk-span style={{ color: '#9d2017' }} class="zid-inline-block zid-discounted-price">
              {props.staticCurrency
                ? props.staticCurrency
                : props?.currency &&
                  getCurrentSymbol(props.currency, navigator?.language || navigator['userLanguage'])?.replace('US', '')}
              {formattedSaleIntegerPart}
              <idk-span>.{saleFractionalPart}</idk-span>
            </idk-span>{' '}
          </>
        )}
        <idk-span
          style={{ color: '#939393', textDecoration: 'line-through', fontWeight: 'initial' }}
          class="zid-inline-block zid-original-price"
        >
          {props.staticCurrency
            ? props.staticCurrency
            : props?.currency &&
              getCurrentSymbol(props.currency, navigator?.language || navigator['userLanguage'])?.replace('US', '')}
          {formattedOriginalIntegerPart}
          <idk-span>.{originalFractionalPart}</idk-span>
        </idk-span>
        {props?.discountPriceOnRight == true && (
          <>
            {' '}
            <idk-span style={{ color: '#9d2017' }} class="zid-inline-block zid-discounted-price">
              {props.staticCurrency
                ? props.staticCurrency
                : props?.currency &&
                  getCurrentSymbol(props.currency, navigator?.language || navigator['userLanguage'])?.replace('US', '')}
              {formattedSaleIntegerPart}
              <idk-span>.{saleFractionalPart}</idk-span>
            </idk-span>
          </>
        )}
      </idk-span>
    );
  }

  if (props.price) {
    const [integerPart, fractionalPart] = parseFloat(props.price).toFixed(2).split('.');
    const formattedIntegerPart = parseInt(integerPart, 10).toLocaleString();

    return (
      <idk-span
        style={{ fontSize: props?.fontSize ? props.fontSize : '16px' }}
        class="zid-inline-block zid-regular-price"
      >
        {props.staticCurrency
          ? props.staticCurrency
          : props?.currency &&
            getCurrentSymbol(props.currency, navigator?.language || navigator['userLanguage'])?.replace('US', '')}
        {formattedIntegerPart}
        <idk-span>.{fractionalPart}</idk-span>
      </idk-span>
    );
  } else {
    return <></>;
  }
};

export const LinkedInEmote = ({ icon }) => {
  if (icon == 'like') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        id="like-consumption-small"
        data-supported-dps="16x16"
      >
        <g>
          <path d="M8 0a8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8 8 8 0 018-8z" fill="none" />
          <circle cx="8" cy="8" r="7" fill="#378fe9" />
          <path
            d="M11.93 7.25h-.55c-.05 0-.15-.19-.4-.46-.37-.4-.78-.91-1.07-1.19a7.13 7.13 0 01-1.73-2.24c-.24-.51-.26-.74-.75-.74a.78.78 0 00-.67.81c0 .14.07.63.1.8a7.54 7.54 0 001 2.2H4.12a.88.88 0 00-.65.28.84.84 0 00-.23.66.91.91 0 00.93.85h.16a.82.82 0 00-.55.24.77.77 0 00-.21.54.81.81 0 00.74.8.8.8 0 00.33 1.42.76.76 0 00-.09.55.87.87 0 00.85.63h2.29a3.8 3.8 0 00.89-.11l1.42-.4h1.9c1.02-.04 1.29-4.64.03-4.64z"
            fill="#d0e8ff"
            fillRule="evenodd"
          />
          <path
            d="M7.43 6.43H4.11a.88.88 0 00-.88 1 .92.92 0 00.93.84h.16a.82.82 0 00-.55.24.77.77 0 00-.21.56.83.83 0 00.74.81.81.81 0 00-.31.63.81.81 0 00.65.8.78.78 0 00-.09.56.86.86 0 00.85.62h2.29a3.8 3.8 0 00.89-.11l1.42-.47h1.9c1 0 1.27-4.64 0-4.64a5 5 0 01-.55 0s-.15-.19-.4-.46h0c-.37-.4-.78-.91-1.07-1.19a7.08 7.08 0 01-1.7-2.25 2.14 2.14 0 00-.32-.52.83.83 0 00-1.16.09 1.39 1.39 0 00-.25.38 1.71 1.71 0 00-.09.3 2.38 2.38 0 00.07.84 4.12 4.12 0 00.27.84 6.65 6.65 0 00.66 1 .18.18 0 01.07.08"
            fill="none"
            stroke="#004182"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    );
  }
  if (icon == 'appreciation') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17.5"
        height="16"
        viewBox="0 0 17.5 16"
        id="support-consumption-small"
        data-supported-dps="16x16"
      >
        <defs>
          <mask
            id="reactions-support-consumption-small-a"
            x="0"
            y="0"
            width="17.5"
            height="16"
            maskUnits="userSpaceOnUse"
          >
            <path d="M8 15a7 7 0 10-7-7 7 7 0 007 7z" fill="#fff" />
          </mask>
        </defs>
        <g mask="url(#reactions-support-consumption-small-a)">
          <circle cx="8" cy="8" r="8" fill="none" />
          <path d="M8 15a7 7 0 10-7-7 7 7 0 007 7z" fill="#d8d8d8" />
          <path d="M8 15a7 7 0 10-7-7 7 7 0 007 7z" fill="#bba9d1" />
          <path
            d="M6.55 10.62h-.21c-.23-.09-1.38-.53-2.15-.74A.25.25 0 014 9.67a.67.67 0 01.11-.5.39.39 0 01.34-.17.69.69 0 01.2 0 1.79 1.79 0 01.42.25l.36.25.33.24.84.33c.11 0 .58.26.55.38s-.53.11-.64.11z"
            fill="#fef2ff"
          />
          <path
            d="M15.47 14.07a23.68 23.68 0 01-3.56-.33h-.06a21.22 21.22 0 01-2.64-.51c-.77-.22-1.53-.5-2.26-.77l-.33-.12c-.7-.25-1.26-.47-1.77-.67l-.2-.07a9.1 9.1 0 01-.9-.4c-.4-.22-.53-.5-.35-.84A.6.6 0 014 10h.2a21.93 21.93 0 012.86.86h1.19L11 11a5.08 5.08 0 00-2-.8c-.25-.06-.48-.13-.53-.29a.66.66 0 01.24-.72 1.09 1.09 0 01.56-.12 3.27 3.27 0 01.7.08l.36.1a4.25 4.25 0 00.86.18 8.87 8.87 0 011.43.3 2.43 2.43 0 012 1.51c-.06-.18 0-.05 0-.11v-.06h.99c.13 0 .7-.14.7 0a5.45 5.45 0 01-.67 3 .17.17 0 01-.14.1z"
            fill="#eae2f3"
          />
          <path d="M13.2 10a.09.09 0 00.1 0z" fill="#d67676" />
          <path
            d="M6.14 3.57a1.43 1.43 0 00-2 0 1.5 1.5 0 000 2.1L6.3 7.92l2.22-2.25a1.5 1.5 0 000-2.1 1.44 1.44 0 00-2 0l-.17.17z"
            fill="#ecaa96"
            fillRule="evenodd"
          />
          <path
            d="M16.92 11.25a2.58 2.58 0 01-.13 1.62 5.29 5.29 0 01-1.21 1.69c-.13.12-4.85-.52-6-.69a58.16 58.16 0 01-6.49-2.7c-.21-.11-.22-.9.37-1.06s2.85.8 3.8.88 2.54.18 3.67.18-1.3-.68-1.7-.82-1-.31-1.08-.64S8.63 9 9 9a6.57 6.57 0 012 .35 13.35 13.35 0 012.45.5A3.1 3.1 0 0115 11c.11.2 1.81.17 1.92.25z"
            fill="none"
            stroke="#493d57"
          />
          <path
            d="M4.07 10.09A.75.75 0 014.59 9c.4-.08 1.18.42 1.72.91a5.73 5.73 0 001.89 1.14"
            fill="none"
            stroke="#493d57"
          />
          <path
            d="M6.22 3.37A1.58 1.58 0 004 5.6L6.4 8l2.42-2.4a1.59 1.59 0 00.43-1.38 1.54 1.54 0 00-.86-1.15 1.52 1.52 0 00-.69-.16 1.58 1.58 0 00-1.12.47l-.18.17z"
            fill="none"
            stroke="#77280c"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    );
  }
  if (icon == 'empathy') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        id="empathy-consumption-small"
        data-supported-dps="16x16"
      >
        <g>
          <path d="M8 0a8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8 8 8 0 018-8z" fill="none" />
          <circle cx="8" cy="8" r="7" fill="#df704d" />
          <path
            d="M7.71 5A2.64 2.64 0 004 8.75l4 4 4-4A2.64 2.64 0 0012 5a2.61 2.61 0 00-1.85-.77h0A2.57 2.57 0 008.3 5l-.3.3z"
            fill="#fff3f0"
            stroke="#77280c"
            fillRule="evenodd"
          />
          <path
            d="M11.43 5.18a2 2 0 01.53.63c.9 1.67-.6 2.72-1.54 3.67-.6.61-1.22 1.22-1.85 1.8M5.79 4.81a2.1 2.1 0 00-.79.11 1.8 1.8 0 00-1 .82A2.6 2.6 0 003.77 7v.09"
            fill="none"
          />
          <path
            d="M7.71 5A2.6 2.6 0 004 5a2.66 2.66 0 000 3.7l4 4 4-4A2.66 2.66 0 0012 5a2.58 2.58 0 00-1.85-.78h0A2.58 2.58 0 008.3 5l-.3.25z"
            fill="none"
            stroke="#77280c"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    );
  }
  if (icon == 'interest') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        id="interest-consumption-small"
        data-supported-dps="16x16"
      >
        <g>
          <path d="M8 0a8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8 8 8 0 018-8z" fill="none" />
          <circle cx="8" cy="8" r="7" fill="#f5bb5c" />
          <path
            d="M8.82 13.4h-1.6a.54.54 0 01-.54-.54v-1.33h2.68v1.33a.54.54 0 01-.54.54z"
            fill="#ffe1b2"
            fillRule="evenodd"
          />
          <path
            d="M6.69 11.79v-.26a3.08 3.08 0 00-.16-1A3.46 3.46 0 006 9.75a3.24 3.24 0 01-1.19-2.49 3.21 3.21 0 016.42 0A3.38 3.38 0 0110 9.8c.07-.05-.08.06-.18.2a1.71 1.71 0 00-.23.47 3.37 3.37 0 00-.15 1v.26"
            fill="#fcf0de"
            fillRule="evenodd"
          />
          <path
            d="M7.46 4.78a2.21 2.21 0 00-1.22.65 2.43 2.43 0 00-.68 1.22"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            d="M8.82 13.4h-1.6a.54.54 0 01-.54-.54v-1.33h2.68v1.33a.54.54 0 01-.54.54z"
            fill="none"
            stroke="#5d3b01"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.68 11.79v-.26a3.37 3.37 0 00-.15-1 2 2 0 00-.26-.47 2.54 2.54 0 00-.37-.43 3.41 3.41 0 01-.37-.39 3.16 3.16 0 01-.72-2h0a3.21 3.21 0 016.42 0 3.25 3.25 0 01-.73 2 3.84 3.84 0 01-.57.57l-.2.21a1.68 1.68 0 00-.22.47 3.37 3.37 0 00-.15 1v.26M4.6 2.64l.61.79M11.42 2.63l-.61.8M8 1.5v1.26"
            fill="none"
            stroke="#5d3b01"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    );
  }
  if (icon == 'praise') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        id="praise-consumption-small"
        data-supported-dps="16x16"
      >
        <defs>
          <mask id="reactions-praise-consumption-small-a" x="0" y="0" width="16" height="16" maskUnits="userSpaceOnUse">
            <path d="M8 1a7 7 0 017 7 7 7 0 01-7 7 7 7 0 01-7-7 7 7 0 017-7z" fill="#fff" fillRule="evenodd" />
          </mask>
        </defs>
        <g>
          <path d="M8 0a8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8 8 8 0 018-8z" fill="none" />
          <g>
            <path d="M8 1a7 7 0 017 7 7 7 0 01-7 7 7 7 0 01-7-7 7 7 0 017-7z" fill="#d8d8d8" />
          </g>
          <g mask="url(#reactions-praise-consumption-small-a)">
            <circle cx="8" cy="8" r="7" fill="#6dae4f" />
            <path d="M8 1a7 7 0 11-7 7 7 7 0 017-7zm0-1a8 8 0 105.66 2.34A8 8 0 008 0z" fill="#fff" />
            <path
              d="M12.13 9.22a9.19 9.19 0 00-.36-2.32A4.29 4.29 0 0110.44 5c-.16-.53-.27-.72-.74-.73a.74.74 0 00-.65.8c0 .24 0 .49.06.72a11.5 11.5 0 00.58 1.92l-4.5-3.38a.75.75 0 00-1.11.07.73.73 0 00.27 1L6.6 7.1l.59.56L3.62 5a.71.71 0 00-.75-.16.69.69 0 00-.46.61.71.71 0 00.36.67L5 7.77l1.35 1-2.9-2.19a.79.79 0 00-.57-.21.8.8 0 00-.54.28c-.31.4-.06.81.26 1.06L4.85 9.4l1.15.85-2.27-1.7a.74.74 0 00-1.09 0 .76.76 0 00.24 1.09l4.1 3c.6.45 2.07.84 2.72.27"
              fill="none"
              stroke="#165209"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              d="M12.61 9.9l-.42-.37a6.69 6.69 0 00-.51-2.14A5.73 5.73 0 0110.47 5c-.16-.53-.27-.72-.74-.73a.74.74 0 00-.65.8c0 .24 0 .49.06.72a8.88 8.88 0 00.55 1.84l-.19-.1-4.31-3.31a.75.75 0 00-1.11.07.73.73 0 00-.1.59.71.71 0 00.37.47L6.55 7l.64.51-3.57-2.67a.74.74 0 00-.57-.21.77.77 0 00-.54.27.77.77 0 00-.1.59.74.74 0 00.36.51L5 7.66l1.35 1-2.9-2.18a.75.75 0 00-.57-.22.76.76 0 00-.54.28.73.73 0 00.26 1.06l2.25 1.69 1.15.85-2.27-1.69a.73.73 0 00-.54-.25.77.77 0 00-.55.25.74.74 0 00.24 1.08L7 12.64a2.68 2.68 0 002.08.51 1.15 1.15 0 001.41 0c.6-.46.41-.51.85-1.13a10.92 10.92 0 001.27-2.12z"
              fill="#dcf0cb"
              fillRule="evenodd"
            />
            <path
              d="M12.13 9.22a9.19 9.19 0 00-.36-2.32A4.29 4.29 0 0110.44 5c-.16-.53-.27-.72-.74-.73a.74.74 0 00-.65.8c0 .24 0 .49.06.72a11.5 11.5 0 00.58 1.92l-4.5-3.38a.75.75 0 00-1.11.07.73.73 0 00.27 1L6.6 7.1l.59.56L3.62 5a.71.71 0 00-.75-.16.69.69 0 00-.46.61.71.71 0 00.36.67L5 7.77l1.35 1-2.9-2.19a.79.79 0 00-.57-.21.8.8 0 00-.54.28c-.31.4-.06.81.26 1.06L4.85 9.4l1.15.85-2.27-1.7a.74.74 0 00-1.09 0 .76.76 0 00.24 1.09l4.1 3a4.48 4.48 0 002.72.62"
              fill="none"
              stroke="#165209"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".5"
            />
            <path
              d="M14.77 11.39a2.23 2.23 0 01-.46-.75 3.65 3.65 0 00-.1-.65 2.39 2.39 0 00-.36-1.08 5.85 5.85 0 01-1.21-2.38c-.16-.53-.27-.72-.74-.73a.74.74 0 00-.5.26.73.73 0 00-.15.54 4.37 4.37 0 00.06.72c.18.92.37 1.68.39 1.73L7.41 5.84a.76.76 0 00-.57-.22.72.72 0 00-.54.29.73.73 0 00.26 1l2.25 1.7.68.56-3.6-2.71a.76.76 0 00-.57-.22A.71.71 0 005 7.58l2.25 1.7 1.35 1-2.89-2.19a.73.73 0 00-1.1.08c-.31.4-.07.81.26 1.06l2.25 1.68 1.12.85L6 10.06a.72.72 0 00-1 0 .7.7 0 00-.14.58.74.74 0 00.34.49l4 3a2.74 2.74 0 001.13.5l.58.09a2.48 2.48 0 01.87.29.83.83 0 00.6 0 3.87 3.87 0 001.77-1.29 3.8 3.8 0 00.7-2 1 1 0 000-.42z"
              fill="none"
              stroke="#165209"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              d="M14.81 11.34l-.45-.34a6.57 6.57 0 00-.51-2.14 5.85 5.85 0 01-1.21-2.38c-.16-.53-.27-.72-.74-.73a.74.74 0 00-.5.26.73.73 0 00-.15.54 4.37 4.37 0 00.06.72c.18.93.37 1.69.39 1.73L7.41 5.79a.75.75 0 00-1.11.07c-.31.41-.06.81.26 1.06l2.25 1.69.68.56-3.6-2.76a.75.75 0 00-1.11.07c-.31.4-.06.81.26 1.06l2.25 1.69 1.35 1L5.71 8a.72.72 0 00-.57-.21.7.7 0 00-.53.28.72.72 0 00-.12.59.74.74 0 00.38.47l2.25 1.69 1.12.85L6 10a.7.7 0 00-1 0 .71.71 0 00-.16.6.72.72 0 00.36.51l4 3a4.23 4.23 0 002 .59 6.68 6.68 0 00.8.41 3.23 3.23 0 002-1.26 4.93 4.93 0 00.86-2.57z"
              fill="#ddf6d1"
              fillRule="evenodd"
            />
            <path d="M5.14 10.32c.57.43 4.43 3.43 4.89 3.59a2.18 2.18 0 001.47 0 1.6 1.6 0 00.5-.31" fill="none" />
            <path
              d="M14.77 11.39a2.23 2.23 0 01-.46-.75 3.65 3.65 0 00-.1-.65 2.39 2.39 0 00-.36-1.08 5.85 5.85 0 01-1.21-2.38c-.16-.53-.27-.72-.74-.73a.74.74 0 00-.5.26.73.73 0 00-.15.54 4.37 4.37 0 00.06.72c.18.92.37 1.68.39 1.73L7.41 5.84a.76.76 0 00-.57-.22.72.72 0 00-.54.29.73.73 0 00.26 1l2.25 1.7.68.56-3.6-2.71a.76.76 0 00-.57-.22A.71.71 0 005 7.58l2.25 1.7 1.35 1-2.89-2.19a.73.73 0 00-1.1.08c-.31.4-.07.81.26 1.06l2.25 1.68 1.12.85L6 10.06a.72.72 0 00-1 0 .7.7 0 00-.14.58.74.74 0 00.34.49l4 3a2.74 2.74 0 001.13.5l.58.09a2.48 2.48 0 01.87.29.83.83 0 00.6 0 3.87 3.87 0 001.77-1.29 3.8 3.8 0 00.7-2 1 1 0 000-.42z"
              fill="none"
              stroke="#165209"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".5"
            />
            <path d="M8.83 2.82l-.73.92" fill="none" stroke="#165209" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.49 1.62l.07 1.2" fill="none" stroke="#165209" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.54 1.63l-.65 1.56" fill="none" stroke="#165209" strokeLinecap="round" strokeLinejoin="round" />
          </g>
        </g>
      </svg>
    );
  }
};

export function generateApiParams(url, params) {
  const urlObj = new URL(url);
  const searchParams = urlObj.searchParams;

  Object.keys(params).forEach((key) => {
    searchParams.set(key, params[key]);
  });

  return urlObj.toString();
}

export function remodifyResponse(responseAlbum) {
  if (!responseAlbum || !responseAlbum.result || !Array.isArray(responseAlbum.result.data)) {
    return responseAlbum;
  }

  responseAlbum.result.data = responseAlbum.result.data.map((item) => {
    if (Array.isArray(item.products)) {
      item.products = item.products.map((product) => {
        if (product.productDetails && typeof product.productDetails === 'object') {
          return { ...product, ...product.productDetails };
        }
        return product;
      });
    }
    return item;
  });

  return responseAlbum;
}

export const addUTMToURL = (url, utmParams) => {
  const urlObj = new URL(url);
  const searchParams = urlObj.searchParams;

  Object.keys(utmParams).forEach((key) => {
    searchParams.set(key, utmParams[key] || 'IdukkiUGC');
  });

  return urlObj.toString();
};
